import styled from 'styled-components';

import { mediaBreakpoint } from '../../utils/mediaBreakpoint';
const DescData = styled.dd`
    ${mediaBreakpoint.up('md')} {
        text-align: right;
    }
`;

export default DescData;
